var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 1024,
    width: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.39 265.398v-96h208v60.44c0 95.821-35.018 131.56-128.907 131.56H298.39zm368.175-46.021v-96h208v60.44c0 95.82-35.019 131.56-128.907 131.56h-79.093zM507.023 477.099v-96h208v60.44c0 95.82-35.019 131.56-128.908 131.56h-79.092zM293.788 693.402v-96h208v60.44c0 95.82-35.019 131.56-128.907 131.56h-79.093zm484.764-55.226v-96h208v60.44c0 95.82-35.019 131.56-128.908 131.56h-79.092zM28.395 851.41v-96h208v60.44c0 95.821-35.018 131.56-128.907 131.56H28.395z",
    fill: "#71ba05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f3a9ab2b5d6a01da484f5a35074f50cb.svg";
export { ForwardRef as ReactComponent };